import React, { Component } from "react";

/**
 * Components
 */
import BlogTitleView from "../component/blogView/blogTitle";
import BlogContentView from "../component/blogView/blogContent";

class PreviewBlogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      author: "",
      content: "",
      photos: [],
      notFound: false,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const cacheKey = searchParams.get("id");

    if (!cacheKey) {
      this.setState({ notFound: true });
      return;
    }

    const cached = localStorage.getItem(cacheKey);

    if (!cached) {
      this.setState({ notFound: true });
      return;
    }

    try {
      const parsed = JSON.parse(cached);
      const { title, author, content, photos } = parsed;

      this.setState({
        title,
        author,
        content: content,
        photos,
      });
    } catch (err) {
      this.setState({ notFound: true });
    }
  }

  calculateReadTime(content) {
    if (!content) return 0;

    const text = content.replace(/<[^>]+>/g, " "); // Remove HTML tags
    const words = text.trim().split(/\s+/).length; // Split by spaces
    const minutes = Math.ceil(words / 200); // 200 words per minute
    return minutes;
  }

  replaceImagePlaceholders = (content, images) => {
    if (!Array.isArray(images)) return content;
    let updatedContent = content;

    images.forEach((url, index) => {
      const placeholder = `[image ${index}]`;
      const imgTag = `<img src="${url}" alt="Image ${index}" style="max-width:100%;padding:5px 0;" />`;
      updatedContent = updatedContent.replaceAll(placeholder, imgTag);
    });

    return updatedContent;
  };

  render() {
    const { title, content, notFound, photos } = this.state;

    if (notFound) {
      return (
        <div className="container mt-5 text-center">
          <h3>🛑 Blog not found in localStorage</h3>
          <p>Check if the draft still exists or the ID is valid.</p>
        </div>
      );
    }

    return (
      <div>
        <div
          className="d-flex align-items-center mb-3"
          style={{
            marginLeft: "10px",
            marginTop: "75px",
          }}
        >
          <button
            className="btn btn-outline-secondary"
            onClick={() => window.history.back()}
          >
            ← Back
          </button>
          <BlogTitleView
            title={title}
            subtitle={""}
            minutesToRead={this.calculateReadTime(content)}
            createdAt={"Not Published Yet"}
          />
        </div>
        <BlogContentView content={content} photos={photos} tags={[]} />
      </div>
    );
  }
}

export default PreviewBlogPage;
